import React, { useEffect, useState } from "react";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import axios from "axios";
import API from "../api";
import Sidebar from "./Sidebar";
import "./Dashboard.css";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement
);

const Dashboard = () => {
  const [datos, setDatos] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/combustible`)
      .then((res) => setDatos(res.data))
      .catch((err) => console.error(err));
  }, []);

  const agrupado = datos.reduce((acc, d) => {
    if (!acc[d.vehiculo]) acc[d.vehiculo] = [];
    acc[d.vehiculo].push(d);
    return acc;
  }, {});

  const labels = Object.keys(agrupado);
  const totalLitros = labels.map((vehiculo) =>
    agrupado[vehiculo].reduce((sum, r) => sum + r.litrosCargados, 0)
  );
  const totalGasto = labels.map((vehiculo) =>
    agrupado[vehiculo].reduce((sum, r) => sum + r.totalGastado, 0)
  );
  const totalKm = labels.map((vehiculo) =>
    agrupado[vehiculo].reduce((sum, r) => sum + (r.kmActual - r.kmAnterior), 0)
  );
  const rendimiento = labels.map((vehiculo, i) =>
    totalLitros[i] > 0 ? totalKm[i] / totalLitros[i] : 0
  );

  const totalCombustible = totalLitros.reduce((a, b) => a + b, 0);
  const totalDinero = totalGasto.reduce((a, b) => a + b, 0);

  return (
    <div className="dashboard-container">
      {/* Botón hamburguesa visible solo en móvil */}
      <button
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Abrir menú"
      >
        ☰
      </button>

      {/* Sidebar con clase dinámica según estado */}
      <Sidebar isOpen={menuOpen} onClose={() => setMenuOpen(false)} />


      <main className="main-content">
        <header className="topbar">
          <h1>Panel de Control</h1>
          <p>Resumen general de cargas, gasto y rendimiento</p>
        </header>

        <section className="cards">
          <div className="card">
            <h4>Combustible Total</h4>
            <p>{totalCombustible.toFixed(1)} L</p>
          </div>
          <div className="card">
            <h4>Gasto Total</h4>
            <p>${totalDinero.toLocaleString()}</p>
          </div>
          <div className="card">
            <h4>Vehículos</h4>
            <p>{labels.length}</p>
          </div>
          <div className="card">
            <h4>Cargas Totales</h4>
            <p>{datos.length}</p>
          </div>
        </section>

        <section className="charts">
          <div className="chart-box">
            <h5>⛽ Litros Cargados por Vehículo</h5>
            <Bar
              data={{
                labels,
                datasets: [
                  {
                    label: "Litros",
                    data: totalLitros,
                    backgroundColor: "#7C5CFC",
                  },
                ],
              }}
              options={{ responsive: true }}
            />
          </div>

          <div className="chart-box">
            <h5>💸 Gasto por Vehículo</h5>
            <Doughnut
              data={{
                labels,
                datasets: [
                  {
                    label: "Gasto",
                    data: totalGasto,
                    backgroundColor: [
                      "#7C5CFC",
                      "#5CAFFC",
                      "#A1A9FE",
                      "#CC6FF8",
                      "#EB7CA6",
                    ],
                  },
                ],
              }}
              options={{ responsive: true }}
            />
          </div>

          <div className="chart-box">
            <h5>📏 Rendimiento (km/L)</h5>
            <Line
              data={{
                labels,
                datasets: [
                  {
                    label: "Rendimiento",
                    data: rendimiento,
                    borderColor: "#4caf50",
                    backgroundColor: "rgba(76, 175, 80, 0.2)",
                  },
                ],
              }}
              options={{ responsive: true }}
            />
          </div>

          <div className="chart-box">
            <h5>🔁 Total KM por Vehículo</h5>
            <Bar
              data={{
                labels,
                datasets: [
                  {
                    label: "KM",
                    data: totalKm,
                    backgroundColor: "#FF6384",
                  },
                ],
              }}
              options={{ responsive: true }}
            />
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
